import { render, staticRenderFns } from "./FactoryQWindow.vue?vue&type=template&id=90c4ad6e&"
import script from "./FactoryQWindow.vue?vue&type=script&lang=js&"
export * from "./FactoryQWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports